module.exports = __webpack_public_path__ + "static/media/ic_automate.372bed58.svg";